module.exports = __webpack_public_path__ + "static/media/beach.667f4f17.jpg";